import React from 'react';
import PropTypes from 'prop-types';

import './canonical-form-option.scss';

function CanonicalFormOption(props) {
  const {
    className,
    isFocused,
    isSelected,
    label,
    shouldResetFilter,
    suffix = ''
  } = props;
  let styleName = 'option';
  let message = '';

  if (isSelected) {
    styleName += ' option--selected';
  } else if (isFocused) {
    styleName += ' option--focused';
  }

  if (shouldResetFilter) {
    message = 'Selecting this may change other specs';
  }

  return (
    <div className={className || 'react-select__option'} styleName={styleName}>
      {label}
      {suffix}
      {message && <span styleName="message">{message}</span>}
    </div>
  );
}

CanonicalFormOption.propTypes = {
  className: PropTypes.string,
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  shouldResetFilter: PropTypes.bool,
  suffix: PropTypes.string
};

export default CanonicalFormOption;
